export default "__VITE_ASSET__ebd4ab82__"